import React, { useState } from 'react';
import { Card, Form, Input, Button, Space, Table, message, Select } from 'antd';
import { PlusOutlined, DeleteOutlined, SaveOutlined } from '@ant-design/icons';

const { Option } = Select;
const { TextArea } = Input;

const ProductInfo = () => {
  const [form] = Form.useForm();
  const [keywords, setKeywords] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleGenerateTitle = async () => {
    setLoading(true);
    try {
      // 这里添加调用后端API生成标题的逻辑
      const response = await fetch('/api/v1/ai/generate-title', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(form.getFieldsValue()),
      });
      const data = await response.json();
      form.setFieldsValue({ title: data.title });
      message.success('标题生成成功');
    } catch (error) {
      message.error('标题生成失败');
    }
    setLoading(false);
  };

  const handleGenerateKeywords = async () => {
    setLoading(true);
    try {
      // 这里添加调用后端API生成关键词的逻辑
      const response = await fetch('/api/v1/ai/generate-keywords', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(form.getFieldsValue()),
      });
      const data = await response.json();
      setKeywords(data.keywords);
      message.success('关键词生成成功');
    } catch (error) {
      message.error('关键词生成失败');
    }
    setLoading(false);
  };

  const handleSave = async () => {
    try {
      const values = form.getFieldsValue();
      // 这里添加保存到后端的逻辑
      await fetch('/api/v1/products', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...values,
          keywords,
        }),
      });
      message.success('保存成功');
    } catch (error) {
      message.error('保存失败');
    }
  };

  const columns = [
    {
      title: '关键词',
      dataIndex: 'keyword',
      key: 'keyword',
    },
    {
      title: '搜索量',
      dataIndex: 'searchVolume',
      key: 'searchVolume',
    },
    {
      title: '竞争度',
      dataIndex: 'competition',
      key: 'competition',
    },
    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <Button
          type="text"
          danger
          icon={<DeleteOutlined />}
          onClick={() => {
            setKeywords(keywords.filter(k => k.keyword !== record.keyword));
          }}
        />
      ),
    },
  ];

  return (
    <div>
      <Card title="产品信息生成" style={{ marginBottom: 16 }}>
        <Form
          form={form}
          layout="vertical"
        >
          <Form.Item
            name="productName"
            label="产品名称"
            rules={[{ required: true, message: '请输入产品名称' }]}
          >
            <Input placeholder="请输入产品名称" />
          </Form.Item>

          <Form.Item
            name="category"
            label="产品类别"
            rules={[{ required: true, message: '请选择产品类别' }]}
          >
            <Select placeholder="请选择产品类别">
              <Option value="electronics">电子产品</Option>
              <Option value="home">家居用品</Option>
              <Option value="clothing">服装</Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="description"
            label="产品描述"
            rules={[{ required: true, message: '请输入产品描述' }]}
          >
            <TextArea rows={4} placeholder="请输入产品描述" />
          </Form.Item>

          <Form.Item
            name="title"
            label="产品标题"
            rules={[{ required: true, message: '请输入产品标题' }]}
          >
            <Input.TextArea rows={2} placeholder="请输入产品标题" />
          </Form.Item>

          <Space style={{ marginBottom: 16 }}>
            <Button
              type="primary"
              onClick={handleGenerateTitle}
              loading={loading}
            >
              生成标题
            </Button>
            <Button
              onClick={handleGenerateKeywords}
              loading={loading}
            >
              生成关键词
            </Button>
          </Space>

          <Table
            columns={columns}
            dataSource={keywords}
            rowKey="keyword"
            pagination={false}
          />

          <Form.Item style={{ marginTop: 16 }}>
            <Button
              type="primary"
              icon={<SaveOutlined />}
              onClick={handleSave}
            >
              保存产品信息
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default ProductInfo; 